<template>
 <div class="content">
    <div class="content-select">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="select-title">
            <div class="title-img">
              <img src="@/assets/appraisal/select-icon.png" alt="" />
            </div>
            <div class="title-info">
              <span>查看报名信息</span>
            </div>
          </div>
        </el-col>
        <el-col :span="2" :offset="14">
            <div class="select-serch">
                <el-button icon="el-icon-arrow-left" type="primary" size="small" @click="handleBack">返回上一页</el-button>
            </div>
        </el-col>
      </el-row>
    </div>
    <div class="content-info" v-loading="detailLoading" element-loading-text="加载活动信息...">
      <div class="content-info-inner">
        <div class="content-info-header">
          <div class="content-info-title-row">
            <span class="content-info-title">{{ bannerInfo.name }}</span>
            <span class="content-info-title-sub">{{ bannerInfo.nameHint }}</span>
          </div>
          <span
            v-if="bannerStatusLabel"
            class="content-info-status"
            :class="{ 'is-offline': Number(bannerInfo.status) === 2 }"
          >{{ bannerStatusLabel }}</span>
        </div>
        <div class="content-info-meta">
          <div class="content-info-meta-col">
            <div class="content-info-meta-label">关联机构</div>
            <div class="content-info-meta-value">{{ bannerInfo.institutionName }}</div>
          </div>
          <div class="content-info-meta-col">
            <div class="content-info-meta-label">关联培训项目</div>
            <div class="content-info-meta-value">{{ bannerInfo.projectName }}</div>
          </div>
          <div class="content-info-meta-col">
            <div class="content-info-meta-label">开班时间</div>
            <div class="content-info-meta-value">{{ bannerInfo.openClassTime }}</div>
          </div>
          <div class="content-info-meta-col">
            <div class="content-info-meta-label">创建时间</div>
            <div class="content-info-meta-value">{{ bannerInfo.createTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-header" v-if="activityId">
      <myTableSearch
        v-if="detailLoaded"
        :isOperate="true"
        :operateWidth="320"
        :formData="formData"
        :tableLabel="tableLabel"
        :queryFn="queryFn"
        :queryParams="queryParams"
        @successQuery="successQuery"
        :searchColLg="6"
        ref="tableRef"
        dataRow="rows"
      >
        <template slot="signStatus" slot-scope="scope">
          <span
            v-if="formatSignStatus(scope.row.signStatus) !== '-'"
            :class="signStatusTagClass(scope.row.signStatus)"
          >{{ formatSignStatus(scope.row.signStatus) }}</span>
          <span v-else class="signup-person-tag signup-person-tag--plain">-</span>
        </template>
        <template slot="auditStatus" slot-scope="scope">
          <template v-if="!shouldHideAuditWhenCancelled(scope.row)">
            <span
              v-if="formatAuditStatus(scope.row.auditStatus) !== '-'"
              :class="auditStatusTagClass(scope.row.auditStatus)"
            >{{ formatAuditStatus(scope.row.auditStatus) }}</span>
            <span v-else class="signup-person-tag signup-person-tag--plain">-</span>
          </template>
        </template>
        <template slot="operate" slot-scope="scope" width="300">
          <template v-if="Number(scope.row.auditStatus) === 0">
            <el-button type="text" size="small" @click="handleAuditPass(scope.row)">通过</el-button>
            <el-button type="text" size="small" style="color: rgb(241, 74, 63)" @click="handleAuditReject(scope.row)"
              >拒绝</el-button
            >
          </template>
          <span v-else>-</span>
        </template>
      </myTableSearch>
    </div>
  </div>
</template>

<script>
import refreshIcon from "@/assets/pages/appointment/refresh.png";
import {
  auditTrainingClassSignupInfo,
  getTrainingClassSignupInfoPersonList,
  updateTrainingClassSignupInfoPerson,
} from "@/api/training";

export default {
  name: "SignupInfoDetail",
  data() {
    return {
      detailLoading: false,
      detailLoaded: false,
      /** 活动详情中的机构、项目 id，用于列表 query */
      activityContext: {
        institutionId: "",
        projectId: "",
      },
      /** 顶部信息条 */
      bannerInfo: {
        name: "—",
        nameHint: "（活动名称）",
        status: "",
        institutionName: "—",
        projectName: "—",
        openClassTime: "—",
        createTime: "—",
      },
      refreshIcon,
      currentPage: 1,
      downloadTemplateLoading: false,
      importLoading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50],
      },
      isSubscribeDialog: false, // 新增 / 编辑 / 查看活动弹窗
      isEdit: false,
      isView: false,
      editData: {},
      policyDialogTitle: "",
      isImportResultDialog: false, //导入结果弹窗
      importResultData: "", //导入结果
      formData: [
        {
          label: "审核状态",
          type: "select",
          key: "auditStatus",
          colLg: 5,
          placeholder: "审核状态",
          data: [
            { dictLabel: "全部", dictValue: "" },
            { dictLabel: "待审核", dictValue: 0 },
            { dictLabel: "已通过", dictValue: 1 },
            { dictLabel: "已拒绝", dictValue: 2 },
          ],
        },
        {
          label: "报名状态",
          type: "select",
          key: "signStatus",
          colLg: 5,
          placeholder: "状态",
          data: [
            { dictLabel: "全部", dictValue: "" },
            { dictLabel: "已报名", dictValue: 0 },
            { dictLabel: "已取消", dictValue: 1 },
          ],
        },
        {
          label: "报名时间",
          type: "daterange",
          key: "signTimeRange",
          colLg: 8,
          placeholder: "报名时间",
          screen(val) {
            if (!val || !Array.isArray(val) || val.length < 2) {
              return {};
            }
            const start = val[0] != null ? String(val[0]).split(" ")[0] : "";
            const end = val[1] != null ? String(val[1]).split(" ")[0] : "";
            return {
              signTimeStart: start,
              signTimeEnd: end,
            };
          },
        },
      ],
      tableLabel: [
        {
          prop: "signTime",
          label: "报名时间",
          width: 180,
          minWidth: 120,
        },
        {
          prop: "userName",
          label: "姓名",
          width: 200,
          minWidth: 140,
        },
        {
          prop: "userPhone",
          label: "手机号",
          width: 200,
          minWidth: 140,
        },
        {
          prop: "institutionName",
          label: "报名机构",
          width: 220,
          minWidth: 160,
          isTooltip: true,
        },
        {
          prop: "projectName",
          label: "报名项目",
          width: 220,
          minWidth: 160,
          isTooltip: true,
        },
        {
          prop: "signStatus",
          label: "报名状态",
          width: 100,
          align: "center",
        },
        {
          prop: "auditStatus",
          label: "审核状态",
          width: 100,
          align: "center",
        },
      ],
    };
  },
  computed: {
    activityId() {
      const id = this.$route.query && this.$route.query.id;
      return id != null && String(id).trim() !== "" ? String(id).trim() : "";
    },
    bannerStatusLabel() {
      const s = Number(this.bannerInfo.status);
      if (s === 1) return "在线";
      if (s === 2) return "下线";
      return "";
    },
  },
  watch: {
    "$route.query.id"() {
      this.initPage();
    },
  },
  mounted() {
    this.initPage();
  },
  methods: {
    applyActivityDetail(row) {
      const d = row || {};
      this.bannerInfo = {
        ...this.bannerInfo,
        name: d.name != null && d.name !== "" ? String(d.name) : "—",
        nameHint: "（活动名称）",
        status: d.status,
        institutionName:
          d.institutionName != null && d.institutionName !== "" ? String(d.institutionName) : "—",
        projectName: d.projectName != null && d.projectName !== "" ? String(d.projectName) : "—",
        openClassTime: this.formatOpenClassTimeList(d),
        createTime: d.createTime != null && d.createTime !== "" ? String(d.createTime) : "—",
      };
      this.activityContext = {
        institutionId:
          d.institutionId != null && d.institutionId !== ""
            ? String(d.institutionId)
            : d.cultivateInstitutionId != null && d.cultivateInstitutionId !== ""
              ? String(d.cultivateInstitutionId)
              : "",
        projectId:
          d.projectId != null && d.projectId !== ""
            ? String(d.projectId)
            : d.cultivateProjectId != null && d.cultivateProjectId !== ""
              ? String(d.cultivateProjectId)
              : "",
      };
    },
    async loadActivityDetail() {
      if (!this.activityId) return false;
      this.detailLoading = true;
      try {
        const res = await auditTrainingClassSignupInfo({ id: this.activityId });
        if (res && res.code === 200 && res.data) {
          this.applyActivityDetail(res.data);
          return true;
        }
        this.$message.error((res && res.msg) || "获取活动详情失败");
        return false;
      } catch (e) {
        console.error(e);
        this.$message.error("获取活动详情失败");
        return false;
      } finally {
        this.detailLoading = false;
      }
    },
    async initPage() {
      if (!this.activityId) {
        this.$message.warning("缺少活动 id 参数");
        this.detailLoaded = false;
        return;
      }
      this.detailLoaded = false;
      await this.loadActivityDetail();
      this.detailLoaded = true;
      await this.$nextTick();
      this.$refs.tableRef && this.$refs.tableRef.handleSearch();
    },
    buildPersonListQuery(raw) {
      const q = raw || {};
      const toYmd = (v) => (v != null && v !== "" ? String(v).split(" ")[0] : "");
      const query = {
        signTimeStart: toYmd(q.signTimeStart),
        signTimeEnd: toYmd(q.signTimeEnd),
        activityId: this.activityId || "",
        institutionId: this.activityContext.institutionId || "",
        projectId: this.activityContext.projectId || "",
      };
      if (q.auditStatus !== undefined && q.auditStatus !== null && q.auditStatus !== "") {
        const n = Number(q.auditStatus);
        if (!Number.isNaN(n)) query.auditStatus = n;
      }
      if (q.signStatus !== undefined && q.signStatus !== null && q.signStatus !== "") {
        const n = Number(q.signStatus);
        if (!Number.isNaN(n)) query.signStatus = n;
      }
      return query;
    },
    queryFn(queryParams) {
      if (!this.activityId) {
        return Promise.resolve({ code: 200, data: { rows: [], total: 0 } });
      }
      const payload = {
        pageNum: queryParams.pageNum,
        pageSize: queryParams.pageSize,
        query: this.buildPersonListQuery(queryParams.query || {}),
      };
      return getTrainingClassSignupInfoPersonList(payload);
    },
    formatOpenClassTimeList(row) {
      const v = row && row.openClassTimeList;
      if (v == null || v === "") return "—";
      if (Array.isArray(v)) {
        const s = v.map((x) => (x != null ? String(x) : "")).filter(Boolean);
        return s.length ? s.join("、") : "—";
      }
      if (typeof v === "string") {
        try {
          const parsed = JSON.parse(v);
          if (Array.isArray(parsed)) {
            return parsed.length ? parsed.join("、") : "—";
          }
        } catch (e) {
          /* 非 JSON 则原样展示 */
        }
        return v || "—";
      }
      return "—";
    },
    formatAuditStatus(v) {
      const n = Number(v);
      if (n === 0) return "待审核";
      if (n === 1) return "已通过";
      if (n === 2) return "已拒绝";
      return "-";
    },
    formatSignStatus(v) {
      const n = Number(v);
      if (n === 0) return "已报名";
      if (n === 1) return "已取消";
      return "-";
    },
    /** 已取消时不展示审核状态（与列表设计一致） */
    shouldHideAuditWhenCancelled(row) {
      return Number(row && row.signStatus) === 1;
    },
    signStatusTagClass(v) {
      const n = Number(v);
      if (n === 0) return "signup-person-tag signup-person-tag--sign-enrolled";
      if (n === 1) return "signup-person-tag signup-person-tag--sign-cancelled";
      return "signup-person-tag signup-person-tag--plain";
    },
    auditStatusTagClass(v) {
      const n = Number(v);
      if (n === 0) return "signup-person-tag signup-person-tag--audit-pending";
      if (n === 1) return "signup-person-tag signup-person-tag--audit-passed";
      if (n === 2) return "signup-person-tag signup-person-tag--audit-rejected";
      return "signup-person-tag signup-person-tag--plain";
    },
    signupPersonRecordId(row) {
      if (!row) return "";
      if (row.id != null && row.id !== "") return String(row.id);
      if (row.signInfoId != null && row.signInfoId !== "") return String(row.signInfoId);
      return "";
    },
    handleAuditPass(row) {
      this.submitAudit(row, 1, "确定审核通过该报名吗？");
    },
    handleAuditReject(row) {
      this.submitAudit(row, 2, "确定拒绝该报名吗？");
    },
    submitAudit(row, auditStatus, confirmText) {
      const id = this.signupPersonRecordId(row);
      if (!id) {
        this.$message.warning("无法获取报名记录 id");
        return;
      }
      this.$confirm(confirmText, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateTrainingClassSignupInfoPerson({ id, auditStatus })
            .then((res) => {
              if (res && res.code === 200) {
                this.$message.success("操作成功");
                this.handleRefresh();
              } else {
                this.$message.error((res && res.msg) || "操作失败");
              }
            })
            .catch((err) => {
              console.error(err);
              this.$message.error("操作失败");
            });
        })
        .catch(() => {});
    },
    handleRefresh() {
      this.$refs.tableRef && this.$refs.tableRef.handleSearch();
    },
    successQuery() {},
    handleBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;

  &-select {
    height: 50px;
    .select-title {
      height: 46px;
      background: url("~@/assets/appraisal/selectBg.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      gap: 12px;
      padding-left: 16px;
      .title-img {
        width: 18px;
        height: 18px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .title-info {
        color: var(--vt-c-black-mute-soft);
        font-size: 16px;
        font-weight: 700;
      }
    }
    .select-serch {
      margin-top: 12px;
      display: flex;
      align-items: center;
      gap: 8px;
      .serch-hint {
        color: var(--vt-c-black-mute-soft);
        font-size: 14px;
        font-weight: 400;
      }
      .serch-info {
        height: 28px;
        display: flex;
        align-items: center;
        gap: 12px;
        .info-item {
          width: 120px;
          height: 28px;
          text-align: center;
          line-height: 28px;
          background: var(--vt-c-blue-mute);
          color: var(--vt-c-blue);
          border-radius: 2px;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            opacity: 0.8;
          }

          &.active {
            background: var(--vt-c-blue);
            color: var(--vt-c-white);
          }

          &:active:not(.active) {
            transform: scale(0.98);
          }
        }
      }
    }
  }
  &-info {
    margin: 16px 24px;
    padding-bottom: 24px;
    position: relative;
    border-radius: 8px;
    background: #f0f7ff;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(24, 144, 255, 0.06);

    &::before {
      content: "";
      position: absolute;
      right: -8%;
      bottom: -35%;
      width: 55%;
      height: 95%;
      background: radial-gradient(
        ellipse 80% 60% at 70% 100%,
        rgba(255, 255, 255, 0.65) 0%,
        rgba(255, 255, 255, 0.12) 45%,
        transparent 70%
      );
      pointer-events: none;
    }
  }

  &-info-inner {
    position: relative;
    z-index: 1;
    padding: 20px 24px 22px;
  }

  &-info-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 16px;
  }

  &-info-title-row {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 8px 10px;
    min-width: 0;
  }

  &-info-title {
    font-size: 18px;
    font-weight: 600;
    color: #1890ff;
    line-height: 1.35;
  }

  &-info-title-sub {
    font-size: 13px;
    font-weight: 400;
    color: #8c8c8c;
  }

  &-info-status {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 2px 12px;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    color: #fff;
    background: #52c41a;
    border-radius: 4px;

    &.is-offline {
      background: #ff4d4f;
    }
  }

  &-info-meta {
    display: flex;
    align-items: stretch;
  }

  &-info-meta-col {
    flex: 1;
    min-width: 0;
    padding: 0 20px;
    border-right: 1px dashed rgba(24, 144, 255, 0.25);

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      border-right: none;
      padding-right: 0;
    }
  }

  &-info-meta-label {
    font-size: 12px;
    color: #8c8c8c;
    line-height: 1.5;
    margin-bottom: 6px;
  }

  &-info-meta-value {
    font-size: 14px;
    color: #262626;
    line-height: 1.5;
    word-break: break-word;
  }
  &-header {
    padding: 0 24px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    /deep/.myTableSearch {
      padding: 0;
      height: 740px;
      display: flex;
      flex-direction: column;

      /deep/.el-table {
        flex: 1;
        overflow: auto;
      }
    }
  }
}

.link-text {
  color: #409eff;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.toolbar-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;

  .toolbar-icon {
    width: 24px;
    height: 24px;
  }

  .add-icon {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }

  .toolbar-left {
    display: flex;
    align-items: center;
    gap: 12px;
    .tool-btn {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      transition: all 0.2s;
      background-color: #fcfcfcff;
    }
    .list-title {
      font-size: 14px;
      font-weight: 400;
      color: var(--vt-c-blue-soft);
    }
  }

  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 12px;

    .import-upload {
      display: inline-block;

      /deep/.el-upload {
        display: inline-block;
      }
    }

    .el-button {
      height: 36px;
      padding: 0 16px;
    }
  }
}

.status-tag {
  border-radius: 14px;
  padding: 0 12px;
  font-weight: 500;
  border: none;
}

/* 报名列表：报名状态 / 审核状态 标签 */
.signup-person-tag {
  display: inline-block;
  padding: 2px 10px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 4px;
  font-weight: 500;
  white-space: nowrap;
}

.signup-person-tag--sign-enrolled {
  background: #f6ffed;
  color: #389e3d;
}

.signup-person-tag--sign-cancelled {
  background: #f5f5f5;
  color: #595959;
}

.signup-person-tag--audit-pending {
  background: #fff1f0;
  color: #cf1322;
}

.signup-person-tag--audit-passed {
  background: #e6f7ff;
  color: #096dd9;
}

.signup-person-tag--audit-rejected {
  background: #fff2e8;
  color: #d4380d;
}

.signup-person-tag--plain {
  color: #bfbfbf;
  background: transparent;
}

.cell-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>